<sbnb-progress-stepper [selectedIndex]="signupStepperService.currentStep">
  <cdk-step
    *ngFor="let step of signupStepperService.steps"
    [label]="step.label"
    [completed]="step.completed"></cdk-step>
</sbnb-progress-stepper>

<router-outlet class="absolute"></router-outlet>
